var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'loading-overlay': true, 'loading-overlay-hide': !_vm.show}},[_c('div',{staticClass:"d-flex h-100 w-100 justify-content-center"},[_c('div',{staticClass:"align-self-center"},[_c('icon',{attrs:{"name":"spinner","pulse":""}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-059d0f0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingOverlay.vue
// module id = null
// module chunks = 